import { Tabs } from 'antd';
import AvaProductUsage from './AvaProductUsage';
import SaveAndBuildCredit from './SaveAndBuildCredit';
import RentReportingComponent from './RentReportingComponent';
import LoaderComponent from '../../Loader';
import { PersistedTabs } from '../../PersistedSections';

const { TabPane } = Tabs;

export default function Products({
  loading,
  summaryData,
  creditCards,
  getData,
  userId,
  getAllCreditCardData,
  ccDomains,
  loanDetails,
  paymentAttempts,
  autoPayStatus
}) {
  return <>
    {
      loading ? <LoaderComponent /> : 
        (
         <>
            <PersistedTabs name="products-tab" defaultActiveKey="1" centered>
              <TabPane tab="Ava Credit Card" key="1">
                <AvaProductUsage
                  creditCards={creditCards}
                  ccDomains={ccDomains}
                  loading={loading}
                  refreshList={getData}
                  userSummary={summaryData.userSummary}
                  stripeCards={summaryData?.stripeCards}
                  getAllCreditCardData={getAllCreditCardData}
                  paymentAttempts={paymentAttempts}
                  autoPayStatus={autoPayStatus} />
              </TabPane>
              <TabPane tab="Save & Build Credit" key="2">
                <SaveAndBuildCredit
                  buildCredits={summaryData.saveAndBuildCredit}
                  userSummary={summaryData.userSummary}
                  loading={loading}
                  refreshList={getData}
                  loanDetails={loanDetails}
                  stripeCards={summaryData?.stripeCards}
                  paymentAttempts={paymentAttempts} 
                  autoPayStatus={autoPayStatus} />
              </TabPane>
              <TabPane tab="Rent Reporting" key="3">
                <RentReportingComponent userId={userId} />
              </TabPane>
            </PersistedTabs>
         </>
        )
    }
  </>
}